import { IInventoryFilterValue } from './types';

export const EMPTY_INVENTORY_FILTER: IInventoryFilterValue = {
  onlyWithInventory: false,
  shippingLocation: null,
};
